import { render, staticRenderFns } from "./VehicleRemarksList.vue?vue&type=template&id=b7e390b6&scoped=true&"
import script from "./VehicleRemarksList.vue?vue&type=script&lang=js&"
export * from "./VehicleRemarksList.vue?vue&type=script&lang=js&"
import style0 from "./VehicleRemarksList.vue?vue&type=style&index=0&id=b7e390b6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7e390b6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VChip } from 'vuetify/lib/components/VChip';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VBtn,VChip,VDataTable})
